module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Screen Sharing":"Screen Sharing","Select content to share":"Select content to share","Share":"Share","Change Content":"Change Content","Stop Sharing":"Stop Sharing","Screen sharing paused":"Screen sharing paused"},"zh":{"Screen Sharing":"共享屏幕","Select content to share":"选择你要共享的区域","Share":"开始共享","Change Content":"新的共享","Stop Sharing":"停止共享","Screen sharing paused":"屏幕分享暂停中"}}')
  delete Component.options._Ctor
}
